var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 5C11.7539 5 12.5001 4.25381 12.5001 3.33333C12.5001 2.41286 11.7539 1.66667 10.8334 1.66667C9.91294 1.66667 9.16675 2.41286 9.16675 3.33333C9.16675 4.25381 9.91294 5 10.8334 5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6484 10.225C11.8526 10.5317 12.1576 10.7642 12.5076 10.8808L14.7367 11.6242L15.2642 10.0442L13.0351 9.30083L11.6492 7.22167C11.488 6.98095 11.2672 6.78603 11.0084 6.65583L9.8134 6.05833C9.45789 5.8806 9.05035 5.83653 8.66506 5.93417L6.00423 6.59833C5.77068 6.65652 5.55249 6.76455 5.36463 6.91501C5.17677 7.06547 5.02369 7.2548 4.9159 7.47L3.4209 10.4608L4.91173 11.2067L6.40673 8.21583L8.25923 7.7525L6.7559 14.7075L3.69423 16.8133L4.6384 18.1867L7.7009 16.08C8.05173 15.8383 8.29506 15.4758 8.38423 15.0592L8.81506 13.0692L10.9126 14.6425L11.6834 18.4967L13.3176 18.1692L12.5467 14.3133C12.4658 13.9117 12.2397 13.5539 11.9117 13.3083L10.1026 11.9517L10.6417 8.71417L11.6484 10.225Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalk);
export default __webpack_public_path__ + "static/media/walk.8b28ca8d618b0cbe956b439f14b080de.svg";
export { ForwardRef as ReactComponent };